export function getGroupValue(item: any, colKey: string) {
    return item.groups.find((group) => group.key === colKey)?.value?.toLowerCase?.() ?? null;
}

export function getFieldValue(item: any, colKey: string) {
    return item.fields.find((field) => field.key === colKey)?.value ?? null;
}
